import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { action, makeObservable } from 'mobx';

const purchaseContractForm = {
  fields: {
    acquisitionPrice: {
      value: '',
      error: null,
      rule: '',
    },
    acquisitionDate: {
      value: '',
      error: null,
      rule: '',
      message: '',
    },
    sellerName: {
      value: '',
      error: null,
      rule: '',
    },
    sellerCredit: {
      value: '',
      error: null,
      rule: '',
    },
    // Special Conditions UI is parked pending business review. The field is
    // commented out so the form never reads or writes it: with no key in
    // form.fields, getFormValues() omits it entirely and GenericDocReview's
    // mergeUiData leaves the stored value untouched on save.
    // specialConditions: {
    //   value: [],
    //   error: null,
    //   rule: '',
    // },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class PurchaseContractFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super({ ...purchaseContractForm }, globalStore);
    makeObservable(this, {
      load: action,
    });
  }

  load(data: Record<string, any>) {
    this.loadForm(data);
  }
}
